import * as firebase from 'firebase'
import { Store } from 'vuex';

export default {
  state: {
    tracks: null
  },
  mutations: {
    setTracks(state, payload) {
        console.log("PL",payload);
      state.tracks = payload
    },
    
  },
  actions: {
    loadTracks({ commit }) {
        console.log("LOAD STATUS");
      firebase
        .database()
        .ref('tracks')
        .on('value', function(snapshot) {
            console.log(snapshot);
            console.log(snapshot.val());
          commit('setTracks', snapshot.val())
        });
    },
  },
  getters: {
    getTracks(state) {
        console.log("GET STATUS");
      return state.tracks
    },
    
  }
}


// WEBPACK FOOTER //
// ./src/store/tracks/index.js